<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-free-delivery"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="icon-close" @click="close()">
                        <img class="img-fluid" src="@/assets/icon/otp_icon_close@2x.png">
                    </div>
                    <div class="icon-check">
                        <img class="img-fluid" src="@/assets/icon/icon_success.svg">
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="text-title">{{lbl.shipping.modal_success.title}}</div>
                    <div class="text-delivery">{{lbl.shipping.modal_success.text_delivery}}</div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-view-reward" @click="clickOk()">
                        <div class="btn-txt">
                            {{lbl.shipping.modal_success.btn_view}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//helper
import Locale from '@/helper/locale/locale.js';
import CacheHelper from "@/helper/CacheHelper.js";

export default {
    name: 'FreeDeliverySuccessModal',
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            tag: null,

            busModal: null,
            cache: new CacheHelper('session'),
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickOk: function(){
            this.cache.setCache('isFromSuccess', true);

            this.hide();
            this.controller.eventClickConfirm({ tag: this.tag });
        },
        close: function () {
            if(this.cache.getCache('isFromBDM')){
                this.cache.removeCache('isFromBDM');
                this.$router.push('/');
            }else{
                this.$router.back();
            }

            this.hide();
        },
        show: function (config) {
            this.tag = config.tag;

            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/input/BaseButton.scss';
.modal-free-delivery {
    .modal-body{
        .modal-base-head{
            .icon-check{
                padding: 40px 0 20px;
                img{
                    width: 62px;
                }
            }
            .icon-close{
                position: absolute;
                top: 20px;
                right: 20px;
                img{
                    width: 18px;
                }
            }
        }

        .modal-base-body{
            font-family: $medium;
            font-size: 1.25rem;

            @include mini-mobile(){
                font-size: 1.1rem;
            }

            .text-title{
                color: $green; 
            }
            .text-delivery{
                color: $bright-gray;
                padding: 15px 0 40px;
            }
        }

        .btn-view-reward{
            @include btn-wrapper();
            width: 100%;
            margin: 0 auto 30px;

            background-color: $white;
            border: 2px solid $blue-gray;
            .btn-txt{
                color: $blue-gray;
            }
        }
    }
}
</style>
<style lang="scss">
.modal-free-delivery{
    .modal-body{
        padding: 0 20px; 
        margin: auto;
        text-align: center;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

}
</style>
